var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"noproject"}},[_c('div',{staticStyle:{"background":"#fff","width":"100%","height":"100%"}},[_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":_vm.zanwu}}),_c('p',{staticStyle:{"font-size":"16px","color":"#000","margin-top":"36px","text-align":"center"}},[_vm._v(" 暂无项目 ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }